/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
      <div class="text-xs-center title">Create Cutom alert</div>
      </v-flex>
      <v-flex xs12>
      <form>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 lg12>
            <v-select v-model="plant" v-validate="'required'" data-vv-name="plant" :items="getPlantList.map(el => el.name)" :error-messages="errors.collect('plant')"
              label="Select Plant" required></v-select>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12>
            <v-select v-model="deviceType" v-validate="'required'" data-vv-name="device" :items="deviceList" :error-messages="errors.collect('device')"
              label="Select Device" required></v-select>
          </v-flex>
          <v-flex xs12 sm12 md6 lg6>
            <v-text-field v-model="blockId" v-validate="'required'" data-vv-name="block" :error-messages="errors.collect('block')" label="Block Id" required></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md6 lg6>
            <v-text-field v-model="roomId" v-validate="'required'" data-vv-name="room" :error-messages="errors.collect('room')" label="Room Id" required></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md6 lg6>
            <v-text-field v-model="deviceId" v-validate="'required'" data-vv-name="deviceId" :error-messages="errors.collect('deviceId')" :append-icon="isApicOrGrid ? 'clear' : 'done'" label="Device ID" :disabled="isApicOrGrid"
              required></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md6 lg6>
            <v-text-field v-model="invId" :error-messages="errors.collect('email')"
            :append-icon="isInverterOrScb ? 'clear' : 'done'" label="Inverter ID" :disabled="isInverterOrScb"
              required></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md6 lg6>
            <v-text-field v-model="scbId" :error-messages="errors.collect('email')"
            :append-icon="isScb ? 'clear' : 'done'" label="SCB ID" :disabled="isScb"
              required></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md6 lg6>
            <v-text-field v-model="wsId" :error-messages="errors.collect('email')"
            :append-icon="isWs ? 'clear' : 'done'" label="WS ID" :disabled="isWs"
              required></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12>
            <v-select v-model="alertStatus" v-validate="'required'" data-vv-name="alertStatus" :items="statusList" :error-messages="errors.collect('alertStatus')"
              label="Alert status" required></v-select>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12>
            <v-select v-model="alertCode" v-validate="'required'" data-vv-name="alertCode" :items="codeList" item-text="text" item-value="code" :error-messages="errors.collect('alertCode')"
              label="Alert Code" required></v-select>
          </v-flex>
          <v-flex xs12 sm12 md4 lg4>
            <v-text-field v-model="alertReason" v-validate="'required'" data-vv-name="alertReason" :error-messages="errors.collect('alertReason')" label="Alert Reason" required></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4 lg4>
            <v-text-field v-model="timestamp" v-validate="'required|max:10|min:10'" :counter="10" :error-messages="errors.collect('timestamp')"
              label="Timestamp" data-vv-name="timestamp" required></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4 lg4>
            <v-text-field v-model="updatedBy" v-validate="'required'" data-vv-name="updatedBy" :error-messages="errors.collect('updatedBy')" label="Updated By" required></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12>
            <v-text-field v-model="message" v-validate="'required'" data-vv-name="message" :error-messages="errors.collect('message')" label="Message" required></v-text-field>
          </v-flex>

          <v-btn color="success" @click.prevent="submit">submit</v-btn>
          <v-btn @click="clear">clear</v-btn>
        </v-layout>
      </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import Vue from 'vue'
  import VeeValidate from 'vee-validate'

  import CustomAlertApi from '@/services/CustomAlert'

  Vue.use(VeeValidate)

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    data: () => ({
      name: '',
      email: '',
      select: null,
      plant: null,
      timestamp: null,
      deviceType: null,
      blockId: null,
      roomId: null,
      deviceId: null,
      invId: null,
      scbId: null,
      wsId: null,
      alertStatus: '',
      alertReason:'',
      alertCode: null,
      message: '',
      updatedBy: '',
      deviceList: [
        'Grid',
        'Inverter',
        'SCB',
        'WS',
        'APIC'
      ],
      statusList: [
        'New',
        'Acknowledge',
        'Resolved'
      ],
      alertCodeList: {
        grid: [
          {
            code: 1,
            text: 'Grid Failure'
          },
          {
            code: 20,
            text: 'Grid Communication'
          }
        ],
        'inverter': [
          {
            code: 2,
           text:'Inverter Failure'
          },
          {
            code: 21,
            text: 'Inverter Communication'
          }
        ],
        'ws': [
          {
            code: 3,
            text: 'Weather Station Failure'
          },
          {
            code: 22,
            text: 'Weather Station Communication'
          }
        ],
        'scb': [
          {
            code: 5,
            text: 'SCB Failure'
          },
          {
            code: 23,
            text: 'SCB Communication'
          }
        ],
        'apic': [
          {
            code: 4,
            text: 'Communication'
          }
        ]
      },
      checkbox: null,
      dictionary: {
        attributes: {
          email: 'E-mail Address'
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters'
            // custom messages
          },
          select: {
            required: 'Select field is required'
          }
        }
      }
    }),

    mounted () {
      this.$validator.localize('en', this.dictionary)
    },

    methods: {
      ...mapMutations(['SET_SHOW_SNACKBAR', 'SET_SNACKBAR_CONTENT']),
      async submit () {
        let isValid = await this.$validator.validateAll();
        if(isValid) {
          let param = {
            plantId: this.getPlantId(this.plant)[0],
            timestamp: this.timestamp,
            deviceType: this.deviceType.toLowerCase(),
            blockId: this.blockId,
            roomId: this.roomId,
            deviceId: this.deviceId,
            inverterId: this.invId,
            scbId: this.scbId,
            wsId: this.wsId,
            alertStatus: this.alertStatus.toLowerCase(),
            alertReason: this.alertReason,
            alertCode: this.alertCode,
            message: this.message,
            updatedBy: this.updatedBy
          }
          let response = await CustomAlertApi.createAlert(param)

          if(response.status === 200) {
            let payload = {
              icon: 'success',
              message: 'Alert has been created'
            }
            this.SET_SNACKBAR_CONTENT(payload)
            this.SET_SHOW_SNACKBAR(true)
          } else {
            let payload = {
              icon: 'error',
              message: 'Alert could not be created'
            }
            this.SET_SNACKBAR_CONTENT(payload)
            this.SET_SHOW_SNACKBAR(true)
          }
        }
      },
      clear () {
        this.plant=null
        this.timestamp=null
        this.deviceType = null
        this.blockId=null
        this.roomId=null
        this.deviceId=null
        this.invId=null
        this.scbId=null
        this.wsId=null
        this.alertStatus = null
        this.alertReason =null
        this.alertCode=null
        this.message=null
        this.updatedBy=null
        this.$validator.reset()
      }
    },

    computed: {
      ...mapGetters(['getPlantList', 'getPlantId']),
      isInverterOrScb() {
        return !(this.deviceType !== null && (this.deviceType.toLowerCase() === 'inverter' || this.deviceType.toLowerCase() === 'scb'))
      },
      isScb() {
        return !(this.deviceType !== null &&  this.deviceType.toLowerCase() === 'scb')
      },
      isApicOrGrid() {
        return !(this.deviceType !== null && (this.deviceType.toLowerCase() === 'apic' || this.deviceType.toLowerCase() === 'grid'))
      },
      isWs() {
        return !(this.deviceType !== null && this.deviceType.toLowerCase() === 'ws')
      },
      codeList() {
        if(this.deviceType === null) {
          return []
        }
        let list = this.alertCodeList[this.deviceType.toLowerCase()];
        if(list === undefined) {
          return []
        }
        return list;
      }
    }
  }
</script>

